import { useContext } from "react";
import UserContext from "../context/UserContext";

export default function useUser() {

    const context = useContext(UserContext);

    if (!context) {
        throw "Contexto necessário para useUser";
    }

    return context;
}